module.exports = __webpack_public_path__ + "static/img/icon_phone_call.06f2967.png";